import { api } from './client'
import type { Priority, Bucket, AppSettings, JournalEntry, WeeklyReview, AiSummary } from '@/types'

export interface CoachingContextData {
  priorities: Priority[]
  buckets: Bucket[]
  settings: AppSettings | null
  recentJournals: JournalEntry[]
  weeklyReviews: WeeklyReview[]
  summaries: AiSummary[]
}

export function fetchCoachingContext(): Promise<CoachingContextData> {
  return api.get('/api/coaching-context')
}
